<template lang="pug">
  v-container
    v-dialog(v-model="dialog")
      v-card
        v-card-title {{ $money(amount) }}
        v-card-text
          v-row
            v-col
              v-text-field(
                v-model="iban"
                filled
                label="IBAN")
          v-row
            v-col
              v-text-field(
                v-model="bic"
                filled
                label="BIC")
          v-row
            v-col
              v-text-field(
                v-model="surname"
                filled
                label="Prénom")
          v-row
            v-col
              v-text-field(
                v-model="name"
                filled
                label="Nom")
          v-row
            v-col
              v-text-field(
                v-model="phoneNumber"
                filled
                label="Téléphone")
    v-row(v-if="$get(requestsToWithdraw, `length`)")
      v-col
        v-list(two-lines)
          v-list-item(
            v-for="({ validatedAt, amount, id, association, createdAt, iban, bic, name, surname }) in requestsToWithdraw"
            :key="id"
            :disabled="!!validatedAt"
            @click="showMoreInfo({ amount, iban, bic, name, surname, phoneNumber: association.phoneNumber })")
            v-list-item-content
              v-list-item-title {{ $money(amount) }}
              v-list-item-subtitle {{ association.user.name }}
            v-list-item-content.justify-end.mr-4 {{ Now.getTimeAgo({ datetime: createdAt, simplify: true }) }}
            template(v-if="!validatedAt")
              v-list-item-action
                utility-action-state(
                  :action="remove"
                  :payload="{ id }")
                  template(#default="{ loading, trigger }")
                    v-btn(
                      @click.stop="trigger"
                      :loading="loading"
                      icon)
                      v-icon {{ mdiDelete }}
              v-list-item-action
                utility-action-state(
                  :action="validate"
                  :payload="{ id }")
                  template(#default="{ loading, trigger }")
                    v-btn(
                      @click.stop="trigger"
                      :loading="loading"
                      icon)
                      v-icon {{ mdiCheck }}
            v-list-item-action(v-else) OK
</template>

<script>
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import { mdiCheck, mdiDelete } from '@mdi/js'
import Now from '@iez/features/now'
import UtilityActionState from '@iez/components/utility/action-state/'
import dayjs from 'dayjs'
import { reactive, toRefs } from '@vue/composition-api'

const route = {
  path: `/manage-requests-to-withdraw`,
  name: `ManageRequestsToWithdraw`
}

export default {
  ...route,

  components: {
    UtilityActionState
  },

  setup () {
    page.topBar.set({
      title: `Gestion des demandes de retrait`
    })

    const requestsToWithdraw = data.get({
      root: `requestsToWithdraw`,
      request: {
        order_by: {
          createdAt: `asc`
        },
        /* where: {
          validatedAt: {
            _is_null: true
          }
        } */
      },
      fields: [
        `id`,
        `validatedAt`,
        `createdAt`,
        `iban`,
        `bic`,
        `name`,
        `surname`,
        `amount`, {
          association: [
            `id`,
            `phoneNumber`, {
              user: [
                `id`,
                `name`
              ]
            }
          ]
        }
      ]
    })

    const state = reactive({
      dialog: false,
      name: ``,
      surname: ``,
      phoneNumber: ``,
      iban: ``,
      bic: ``,
      amount: 0
    })
    const showMoreInfo = ({ amount, iban, bic, name, surname, phoneNumber }) => {
      state.dialog = true
      state.name = name
      state.surname = surname
      state.iban = iban
      state.bic = bic
      state.phoneNumber = phoneNumber
      state.amount = amount
    }

    const remove = ({ id }) => {
      page.confirm({
        title: `Êtes-vous sûr de supprimer ?`,
        callback: () => {
          return data.remove({
            root: `requestsToWithdraw`,
            ids: [id],
            parents: []
          })
        }
      })
    }

    const validate = ({ id }) => {
      page.confirm({
        title: `Es-tu sûr de valider ?`,
        content: `Action irréversible`,
        callback: () => {
          return data.update({
            root: `requestsToWithdraw`,
            id,
            _set: {
              validatedAt: dayjs()
                .format(`YYYY-MM-DDTHH:mm:ss.SSS`)
            },
            fields: [
              `id`
            ]
          })
        }
      })
    }

    return {
      requestsToWithdraw,
      mdiDelete,
      mdiCheck,
      Now,
      remove,
      validate,
      showMoreInfo,
      ...toRefs(state)
    }
  }
}
</script>
